import React, { memo } from 'react';
import { Check, Clock, Brain, Heart, FileText, ArrowDown } from 'lucide-react';
import { PurchaseSection } from './components/PurchaseSection';
import { BonusCard } from './components/BonusCard';
import { TestimonialCard } from './components/TestimonialCard';
import { PurchaseNotification } from './components/PurchaseNotification';
export function App() {
  const scrollToPurchase = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-0">
      <PurchaseNotification data-id="element-1" />

      {/* HERO SECTION - CENTERED LAYOUT */}
      <header className="bg-gradient-to-b from-purple-50 to-white pt-4 pb-8 px-4 md:px-8 overflow-hidden" data-id="element-2">
        <div className="max-w-4xl mx-auto text-center" data-id="element-3">
          <div className="inline-block bg-purple-100 text-purple-800 px-3 py-1 rounded-full text-xs font-bold mb-3 tracking-wide animate-in fade-in duration-700" data-id="element-4">
            PARA PSICOPEDAGOGAS PROFESIONALES
          </div>

          <h1 className="text-2xl md:text-6xl font-extrabold text-gray-900 leading-tight mb-3 animate-in slide-in-from-bottom-4 duration-700 fade-in delay-100" data-id="element-5">
            MEGAPACK <span className="text-purple-600" data-id="element-6">PSICOPEDAGÓGICO</span>{' '}
            PROFESIONAL
            <br data-id="element-7" />
            <span className="text-purple-600" data-id="element-8">1 año</span> de actividades{' '}
            <span className="text-purple-600" data-id="element-9">
              listas para usar sin planificar
            </span>{' '}
            nada
          </h1>

          <p className="text-sm md:text-xl text-gray-600 mb-4 leading-snug max-w-2xl mx-auto animate-in slide-in-from-bottom-4 duration-700 fade-in delay-200" data-id="element-10">
            <span className="font-bold text-gray-900" data-id="element-11">Ahorrá horas</span> todos
            los días con{' '}
            <span className="font-bold text-gray-900" data-id="element-12">
              material profesional
            </span>{' '}
            listo en PDF para aplicar en cualquier sesión,{' '}
            <span className="font-bold text-gray-900" data-id="element-13">
              creado por psicopedagogas profesionales.
            </span>
          </p>

          <div className="relative mb-4 animate-in slide-in-from-bottom-4 duration-700 fade-in delay-300" data-id="element-14">
            <div className="absolute inset-0 bg-purple-200 rounded-full blur-3xl opacity-30 transform scale-90" data-id="element-15"></div>
            <a href="https://checkout.ebookditales.com/cart/42753407844415:1" data-id="element-16">
              <img src="https://cdn.magicpatterns.com/uploads/5dHS56GnYG8eDhPn4bYXu5/Mock_up_Principal-removebg-preview.png" alt="MegaPack Psicopedagógico Profesional" className="relative z-10 w-full max-w-sm mx-auto hover:scale-105 transition-transform duration-500 cursor-pointer drop-shadow-2xl" data-id="element-17" />
            </a>
          </div>

          <div className="animate-in slide-in-from-bottom-4 duration-700 fade-in delay-500" data-id="element-18">
            <a href="https://checkout.ebookditales.com/cart/42753407844415:1" className="bg-orange-500 hover:bg-orange-600 text-white text-sm md:text-lg font-bold py-3 px-6 md:py-4 md:px-8 rounded-xl shadow-lg hover:shadow-orange-500/30 transition-all transform hover:-translate-y-1 inline-flex items-center gap-2" data-id="element-19">
              Sí, quiero recuperar mi tiempo
              <ArrowDown className="w-4 h-4 md:w-5 md:h-5" data-id="element-20" />
            </a>
            <p className="mt-2 text-xs md:text-sm text-gray-500 flex items-center justify-center gap-2" data-id="element-21">
              <Check className="w-3 h-3 md:w-4 md:h-4 text-green-500" data-id="element-22" /> Acceso
              inmediato digital
            </p>
          </div>
        </div>
      </header>

      {/* PROBLEM / AGITATION COPY */}
      <section className="py-20 px-4 md:px-8 max-w-4xl mx-auto" data-id="element-23">
        <div className="text-center mb-12" data-id="element-24">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-25">
            Cada semana perdés <span className="text-purple-600" data-id="element-26">horas</span>{' '}
            armando material
          </h2>
          <p className="text-xl text-gray-600 leading-relaxed max-w-2xl mx-auto" data-id="element-27">
            No aparece en tu agenda. No se factura. Pero está ahí.
            <br data-id="element-28" />
            Pensar actividades. Adaptarlas. Imprimir. Probar si funcionan.
            Volver a empezar.
          </p>
        </div>

        <div className="bg-red-50 border-l-4 border-red-500 p-8 rounded-r-xl mb-12 max-w-2xl mx-auto" data-id="element-29">
          <p className="text-lg font-bold text-gray-900 mb-3" data-id="element-30">
            Y lo más injusto es esto:
          </p>
          <p className="text-gray-700 mb-2" data-id="element-31">
            No es porque no sepas trabajar. No es porque te falte vocación.
          </p>
          <p className="text-red-600 font-bold text-xl" data-id="element-32">
            Es porque nadie te dio un sistema completo.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-33">
          <div className="bg-purple-50 p-8 rounded-2xl border border-purple-100" data-id="element-34">
            <h3 className="text-2xl font-bold text-purple-900 mb-4" data-id="element-35">
              El problema real
            </h3>
            <ul className="space-y-3 text-gray-700" data-id="element-36">
              <li className="flex items-start gap-2" data-id="element-37">
                <span className="text-purple-600 font-bold" data-id="element-38">→</span>
                <span data-id="element-39">
                  Pasás más tiempo planificando que trabajando con niños
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-40">
                <span className="text-purple-600 font-bold" data-id="element-41">→</span>
                <span data-id="element-42">
                  Material suelto de Pinterest que no funciona en sesión real
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-43">
                <span className="text-purple-600 font-bold" data-id="element-44">→</span>
                <span data-id="element-45">Cansancio constante sin tiempo para vos</span>
              </li>
            </ul>
          </div>

          <div className="bg-purple-100 p-8 rounded-2xl border border-purple-200" data-id="element-46">
            <h3 className="text-2xl font-bold text-purple-900 mb-4" data-id="element-47">
              La solución
            </h3>
            <ul className="space-y-3 text-gray-700" data-id="element-48">
              <li className="flex items-start gap-2" data-id="element-49">
                <Check className="w-5 h-5 text-purple-600 flex-shrink-0 mt-0.5" data-id="element-50" />
                <span data-id="element-51">
                  <strong data-id="element-52">1 año completo</strong> de actividades listas
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-53">
                <Check className="w-5 h-5 text-purple-600 flex-shrink-0 mt-0.5" data-id="element-54" />
                <span data-id="element-55">
                  <strong data-id="element-56">Material probado</strong> por psicopedagogas
                  profesionales
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-57">
                <Check className="w-5 h-5 text-purple-600 flex-shrink-0 mt-0.5" data-id="element-58" />
                <span data-id="element-59">
                  <strong data-id="element-60">Descargás, imprimís</strong> y listo para usar
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="text-center" data-id="element-61">
          <p className="text-2xl font-bold text-gray-900 mb-4" data-id="element-62">
            Las psicopedagogas no se cansan de acompañar niños.
            <br data-id="element-63" />
            <span className="text-purple-600" data-id="element-64">
              Se cansan de hacer todo solas.
            </span>
          </p>
          <a href="https://checkout.ebookditales.com/cart/42753407844415:1" className="bg-orange-500 hover:bg-orange-600 text-white text-lg font-bold py-4 px-8 rounded-xl shadow-lg transition-all transform hover:-translate-y-1 inline-flex items-center gap-2 mt-6" data-id="element-65">
            Quiero el sistema completo ahora
            <ArrowDown className="w-5 h-5" data-id="element-66" />
          </a>
        </div>
      </section>

      {/* SOLUTION SECTION */}
      <section className="bg-teal-50 py-24 px-4 md:px-8" data-id="element-67">
        <div className="max-w-5xl mx-auto" data-id="element-68">
          <div className="text-center mb-16" data-id="element-69">
            <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-70">
              Imaginá esto por un momento…
            </h2>
            <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-71">
              Abrís tu computadora. Elegís el material. Imprimís. Entrás a
              sesión tranquila. Sin improvisar. Sin dudar. Sin culpa.
            </p>
          </div>

          <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-teal-100" data-id="element-72">
            <div className="grid md:grid-cols-2" data-id="element-73">
              <div className="p-10 md:p-16 flex flex-col justify-center" data-id="element-74">
                <h3 className="text-2xl md:text-3xl font-bold text-teal-800 mb-6" data-id="element-75">
                  MegaPack Psicopedagógico Profesional
                </h3>
                <p className="text-gray-600 mb-8" data-id="element-76">
                  Un sistema completo de material psicopedagógico en PDF, creado
                  por psicopedagogas, pensado para sesión real y listo para
                  usar. No es teoría. No es inspiración. No es "ideas sueltas".
                </p>

                <ul className="space-y-4 mb-10" data-id="element-77">
                  {['Un año completo de actividades listas para usar', 'Material organizado para sesión real', 'Recursos claros, prácticos y funcionales', 'Actividades para atención, aprendizaje y funciones ejecutivas', 'Ahorro inmediato de tiempo y energía'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-78">
                      <div className="bg-teal-100 p-1 rounded-full mt-0.5" data-id="element-79">
                        <Check className="w-4 h-4 text-teal-600" data-id="element-80" />
                      </div>
                      <span className="text-gray-700 font-medium" data-id="element-81">{item}</span>
                    </li>)}
                </ul>

                <a href="https://checkout.ebookditales.com/cart/42753407844415:1" className="bg-teal-600 hover:bg-teal-700 text-white font-bold py-3 px-6 rounded-lg shadow-md transition-colors self-start inline-block" data-id="element-82">
                  Quiero el sistema completo
                </a>
              </div>
              <div className="bg-teal-600 p-10 flex items-center justify-center" data-id="element-83">
                <div className="grid grid-cols-2 gap-4" data-id="element-84">
                  <div className="bg-white/10 backdrop-blur p-6 rounded-xl text-white text-center" data-id="element-85">
                    <Clock className="w-8 h-8 mx-auto mb-3 text-teal-200" data-id="element-86" />
                    <p className="font-bold" data-id="element-87">Ahorrá +200hs</p>
                    <p className="text-xs text-teal-100" data-id="element-88">
                      de planificación anual
                    </p>
                  </div>
                  <div className="bg-white/10 backdrop-blur p-6 rounded-xl text-white text-center" data-id="element-89">
                    <Brain className="w-8 h-8 mx-auto mb-3 text-teal-200" data-id="element-90" />
                    <p className="font-bold" data-id="element-91">Profesional</p>
                    <p className="text-xs text-teal-100" data-id="element-92">Creado por expertas</p>
                  </div>
                  <div className="bg-white/10 backdrop-blur p-6 rounded-xl text-white text-center" data-id="element-93">
                    <FileText className="w-8 h-8 mx-auto mb-3 text-teal-200" data-id="element-94" />
                    <p className="font-bold" data-id="element-95">+500 Páginas</p>
                    <p className="text-xs text-teal-100" data-id="element-96">
                      Listas para imprimir
                    </p>
                  </div>
                  <div className="bg-white/10 backdrop-blur p-6 rounded-xl text-white text-center" data-id="element-97">
                    <Heart className="w-8 h-8 mx-auto mb-3 text-teal-200" data-id="element-98" />
                    <p className="font-bold" data-id="element-99">Sin Estrés</p>
                    <p className="text-xs text-teal-100" data-id="element-100">Recuperá tu paz</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* BONUSES SECTION */}
      <section className="py-24 px-4 md:px-8 bg-white" data-id="element-101">
        <div className="max-w-7xl mx-auto" data-id="element-102">
          <div className="text-center mb-16" data-id="element-103">
            <span className="text-orange-500 font-bold tracking-wider uppercase text-sm mb-2 block" data-id="element-104">
              Oferta Especial
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-gray-900" data-id="element-105">
              Bonos Gratis por Hoy Solamente
            </h2>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-106">
              Al acceder hoy, te llevás estos 5 recursos exclusivos sin costo
              adicional para potenciar tu práctica profesional.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-107">
            <BonusCard number={1} title="Cuaderno Cognitivo Profesional" description="Cuaderno imprimible con actividades para trabajar atención, memoria, funciones ejecutivas y razonamiento. Listo para usar." image="https://cdn.magicpatterns.com/uploads/4VFZH7519DXjSvbM9CyJvm/Cauderno_Cognitivo_Regalo_1.png" data-id="element-108" />
            <BonusCard number={2} title="Guía de Estrategias Terapéuticas" description="Mini-manual con intervenciones prácticas para déficit atencional, lectura y regulación. Ideal para desbloquear sesiones." image="https://cdn.magicpatterns.com/uploads/smGTmhDtbP5fw2dHLQzhTA/Guia_de_estrategias_terapeuticas_Regalo_2.png" data-id="element-109" />
            <BonusCard number={3} title="Kit de Reportes para Padres" description="Plantillas profesionales ya armadas: reporte inicial, mensual, seguimiento y recomendaciones. Ahorrá horas de redacción." image="https://cdn.magicpatterns.com/uploads/kpzpzSKrBQFGKTQuiWE9DE/Kit_reporte_para_padres_regalo_3.png" data-id="element-110" />
            <BonusCard number={4} title="Checklist Profesional" description="Lista completa para organizar cada sesión: qué evaluar, qué observar y cómo planificar. No olvides ningún detalle." image="https://cdn.magicpatterns.com/uploads/gK3TPonVqk3FDTKjDP5rNo/Check_list_profesional_Bono_4.png" data-id="element-111" />
            <BonusCard number={5} title="Cuaderno de Regulación Emocional" description="Material imprimible para trabajar respiración, identificación emocional y autocontrol. Clave para problemas de conducta." image="https://cdn.magicpatterns.com/uploads/xcFKefaXMwbvzwURtYKEeu/Cuaderno_de_regulacion_profesional_Regalo_5.png" data-id="element-112" />

            {/* CTA Card in Grid */}
            <a href="https://checkout.ebookditales.com/cart/42753407844415:1" className="bg-orange-50 rounded-xl border-2 border-dashed border-orange-300 flex flex-col items-center justify-center p-8 cursor-pointer hover:bg-orange-100 transition-colors group text-center" data-id="element-113">
              <h3 className="text-2xl font-bold text-orange-600 mb-2" data-id="element-114">
                ¡Y mucho más!
              </h3>
              <p className="text-gray-600 mb-6" data-id="element-115">
                Todo el material está pensado para que nunca más te falten
                recursos.
              </p>
              <span className="bg-orange-500 text-white px-6 py-3 rounded-lg font-bold group-hover:scale-105 transition-transform" data-id="element-116">
                Ver Precio Ahora
              </span>
            </a>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="bg-purple-900 py-24 px-4 md:px-8" data-id="element-117">
        <div className="max-w-7xl mx-auto" data-id="element-118">
          <div className="text-center mb-16" data-id="element-119">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-120">
              Ellas ya recuperaron su tiempo
            </h2>
            <p className="text-purple-200" data-id="element-121">
              Cientos de colegas ya están trabajando con el sistema MegaPack.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-122">
            <TestimonialCard name="María González" age={34} location="Buenos Aires" role="Psicopedagoga Clínica" content="Antes pasaba los domingos armando material. Desde que tengo el MegaPack, tengo mis fines de semana libres y mis sesiones están mucho más organizadas. Es una inversión que se paga sola." data-id="element-123" />
            <TestimonialCard name="Laura Martínez" age={41} location="Ciudad de México" role="Consultorio Privado" content="Lo que más valoro es que no son actividades sueltas, es un sistema. Me da seguridad saber que tengo material profesional listo para cualquier caso que llegue a consulta." data-id="element-124" />
            <TestimonialCard name="Andrea López" age={38} location="Bogotá" role="Práctica Independiente" content="La calidad gráfica y pedagógica es excelente. Los padres notan la diferencia cuando les entrego los reportes del kit de regalo. Me hizo ver mucho más profesional." data-id="element-125" />
            <TestimonialCard name="Carolina Ruiz" age={29} location="Santiago" role="Centro Educativo" content="Estaba a punto de dejar la profesión por el agotamiento. Este material me devolvió las ganas. Ahora disfruto las sesiones en lugar de sufrirlas pensando qué voy a hacer." data-id="element-126" />
            <TestimonialCard name="Sofía Fernández" age={45} location="Lima" role="Coordinadora" content="Es como tener una colega experta que ya hizo el trabajo duro por vos. La guía de estrategias terapéuticas me salvó con un paciente muy difícil la semana pasada." data-id="element-127" />
          </div>
        </div>
      </section>

      {/* PURCHASE SECTION */}
      <PurchaseSection data-id="element-128" />

      {/* FAQ / FOOTER */}
      <footer className="bg-gray-50 py-12 px-4 border-t border-gray-200" data-id="element-129">
        <div className="max-w-3xl mx-auto text-center" data-id="element-130">
          <p className="text-gray-500 text-sm mb-4" data-id="element-131">
            Este producto es digital y se envía por correo electrónico
            inmediatamente después de la compra.
          </p>
          <p className="text-gray-400 text-xs" data-id="element-132">
            © 2024 MegaPack Psicopedagógico. Todos los derechos reservados.
          </p>
        </div>
      </footer>

      {/* GUARANTEE SECTION */}
      <section className="py-20 px-4 md:px-8 bg-white" data-id="element-133">
        <div className="max-w-3xl mx-auto" data-id="element-134">
          <div className="bg-emerald-50 rounded-2xl p-8 md:p-10 border border-emerald-100" data-id="element-135">
            <div className="flex flex-col md:flex-row items-start md:items-center gap-6" data-id="element-136">
              <div className="flex-shrink-0" data-id="element-137">
                <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center shadow-md" data-id="element-138">
                  <svg className="w-10 h-10 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-139">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" data-id="element-140" />
                  </svg>
                </div>
              </div>
              <div className="flex-grow" data-id="element-141">
                <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3" data-id="element-142">
                  Garantía de Satisfacción de 7 Días
                </h3>
                <p className="text-gray-700 leading-relaxed" data-id="element-143">
                  Estamos tan seguros de que{' '}
                  <strong data-id="element-144">MEGAPACK PSICOPEDAGÓGICO</strong> va a transformar tu
                  forma de trabajar que te damos 7 días para probarlo. Si sentís
                  que no te ahorra tiempo o no es lo que esperabas, te
                  devolvemos el 100% de tu dinero. Sin preguntas.{' '}
                  <span className="text-emerald-700 font-bold" data-id="element-145">
                    El riesgo es todo nuestro.
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
}